/* [PATCH nastavitve-zavihki v1] skupni hook za profil podjetja.
   Izlocen 1:1 iz ProfilPage.tsx (vrstice 51-126): GET /profil/{cid}, data, set(),
   shrani() = PUT + ponovni GET + toast. Logika, endpointi in sporocila nespremenjeni.
   setPpOdprti({}) iz shrani() je preseljen v PredponeKartica (lokalni state). */
import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import toast from 'react-hot-toast';

export function useProfil(companyId: string) {
  const [data, setData] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  // [PATCH kraj-brez-sklona v1] prazen seznam odvisnosti je pomenil, da se ob
  // menjavi izbranega podjetja profil NE nalozi znova.
  const nalozi = useCallback(() => {
    if (!companyId) return;
    setLoading(true);
    api.get(`/profil/${companyId}`)
      .then(r => setData(r.data))
      .catch(() => toast.error('Napaka pri nalaganju profila'))
      .finally(() => setLoading(false));
  }, [companyId]);

  useEffect(() => { nalozi(); }, [nalozi]);

  const set = (field: string, value: any) =>
    setData((d: any) => ({ ...d, [field]: value }));

  const shrani = async () => {
    setSaving(true);
    try {
      await api.put(`/profil/${companyId}`, data);
      /* [PATCH interne-predpone v1] po shranjevanju ponovno naloz (GET dopolni
         privzetke, ki jih PUT ne vraca) */
      const _r = await api.get(`/profil/${companyId}`);
      setData(_r.data);
      toast.success('Profil shranjen!');
    } catch (e: any) {
      /* [PATCH interne-predpone v1] pokazi backend detail (npr. zavrnjena predpona) */
      toast.error(e?.response?.data?.detail || 'Napaka pri shranjevanju');
    } finally {
      setSaving(false);
    }
  };

  return { data, set, shrani, saving, loading, nalozi };
}
